/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_IntroInputs */

const en_notify_intro = /** @type {(inputs: Notify_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dishly can remind you – on the iPhone only in the installed app (iOS 16.4 or later).`)
};

const de_notify_intro = /** @type {(inputs: Notify_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dishly kann dich erinnern – auf dem iPhone nur in der installierten App (ab iOS 16.4).`)
};

/**
* | output |
* | --- |
* | "Dishly can remind you – on the iPhone only in the installed app (iOS 16.4 or later)." |
*
* @param {Notify_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_intro = /** @type {((inputs?: Notify_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_intro(inputs)
	return en_notify_intro(inputs)
});